export function convertWeekData(payload) {
    if (!Array.isArray(payload)) return [];
    
    return payload.map(item => ({
      week: item.week || item.Week,
      value: Math.floor(Number(item.value || item.Value || 0)),
      isCurrent: item.isCurrent || false
    }));
  }
  
  export function converSalesIndexData(payload) {
    if (!payload || !Array.isArray(payload)) return { abs: [], percentage: [] };
    
    const transformedData = payload.reduce((acc, item) => {
      if (item.abs !== undefined) {
        acc.abs.push({
          label: item.label || item.type,
          data: Array.isArray(item.data) ? item.data : [],
          value: item.abs
        });
      }
      if (item.percentage !== undefined) {
        acc.percentage.push({
          label: item.label || item.type,
          data: Array.isArray(item.data) ? item.data : [],
          value: Math.floor(item.percentage)
        });
      }
      return acc;
    }, { abs: [], percentage: [] });
    
    return transformedData;
  }
  
  // export function convertWeekData(payload) {
  //   if (!Array.isArray(payload)) return [];
    
  //   return payload.map(item => ({
  //     week: item.week || item.Week,
  //     value: Math.floor(Number(item.value || item.Value || 0)),
  //     isCurrent: item.isCurrent || false
  //   }));
  // }
  
  export function transformDispatchComplianceData(data) {
    if (!data || typeof data !== 'object') return [];
    
    const days = ['Thu', 'Fri', 'Sat', 'Sun', 'Mon', 'Tue', 'Wed'];
    
    return days.map(day => ({
      day,
      hrs24: Math.floor(Number(data[`${day}_24hrs`] || data[day]?.hrs24 || 0)),
      hrs48: Math.floor(Number(data[`${day}_48hrs`] || data[day]?.hrs48 || 0)),
      isCurrent: day === 'Wed'
    }));
  }
  
 export function getRegionFromState(state){
  const regions = {
    North: [
      "Jammu and Kashmir",
      "Ladakh",
      "Himachal Pradesh",
      "Punjab",
      "Haryana",
      "Uttarakhand",
      "Delhi",
      "Chandigarh",
      "Uttar Pradesh", "Bihar",
      "Jharkhand",
      "Odisha",
      "West Bengal",
    ],
    South: [
      "Andhra Pradesh",
      "Telangana",
      "Karnataka",
      "Tamil Nadu",
      "Kerala",
      "Puducherry",
      "Lakshadweep",
      "Andaman and Nicobar Islands",
    ],
    East: [
      "Sikkim",
      "Arunachal Pradesh",
      "Assam",
      "Manipur",
      "Meghalaya",
      "Mizoram",
      "Nagaland",
      "Tripura",
    ],
    West: [
      "Rajasthan",
      "Gujarat",
      "Maharashtra",
      "Goa",
      "Chhattisgarh",
      "Madhya Pradesh",
    ],
  };

  for (const [region, states] of Object.entries(regions)) {
    if (states.includes(state)) {
      return region;
    }
  }

  return "Unknown";
}
